import { BaseModel } from '../base-model';

export interface IAppointmentTypeListing {
  Abbr?: string;
  Color?: number;
  Comment?: string;
  Cost?: number;
  DefaultStatus?: number;
  Duration?: number;
  Icon?: number;
  IconUrl?: string;
  Id?: number;
  IsVisitType?: boolean;
  MessageForActualTenant?: number;
  MessageForOwner?: number;
  MessageForVisitor?: number;
  Name?: string;
  Order?: number;
  Private?: boolean;
  TreatAsCancelled?: boolean;
  AppointmentPlaceType?: string;
  MainTypeGoal?: string;
}
export interface IAppointmentTypeCompact {
  Id?: number;
  Name?: string;
  Color?: number;
  Icon?: number;
  Private?: boolean;
  Cost?: number;
  MessageForVisitor?: number;
  MessageForOwner?: number;
  MessageForActualTenant?: number;
  Duration?: number;
  IsVisitType?: boolean;
  DefaultStatus?: number;
  IconUrl?: string;

}
export class AppointmentTypeListing extends BaseModel<IAppointmentTypeListing> implements IAppointmentTypeListing {
  Abbr?: string;
  Color?: number;
  Comment?: string;
  Cost?: number;
  DefaultStatus?: number;
  Duration?: number;
  Icon?: number;
  IconUrl?: string;
  Id?: number;
  IsVisitType?: boolean;
  MessageForActualTenant?: number;
  MessageForOwner?: number;
  MessageForVisitor?: number;
  Name?: string;
  Order?: number;
  Private?: boolean;
  TreatAsCancelled?: boolean;
  AppointmentPlaceType?: string;
  /**
   *
   */
  constructor(options?: { [key: string]: any }) {
    super(options);
  }
}
export class AppointmentTypeCompact extends BaseModel<IAppointmentTypeCompact> implements IAppointmentTypeCompact {
  Id?: number;
  Name?: string;
  Color?: number;
  Icon?: number;
  Private?: boolean;
  Cost?: number;
  MessageForVisitor?: number;
  MessageForOwner?: number;
  MessageForActualTenant?: number;
  Duration?: number;
  IsVisitType?: boolean;
  DefaultStatus?: number;
  IconUrl?: string;
  /**
   *
   */
  constructor(options?: { [key: string]: any }) {
    super(options);
  }
}